import React from "react";
import { Box, Divider, ListItem, Paper } from "@material-ui/core";
import { CreativeMappingsForm, useListStyles } from "pages/CreativeMappings/components";
import { useSelector } from "react-redux";
import { getCreativeMappingById } from "store/features/creativeMappings/overivew";

interface CreateNewMappingFormProps {
    onCancelEdit(id?: number): () => void;
    id?: number;
}

export const CreateNewMappingForm = ({ onCancelEdit, id }: CreateNewMappingFormProps) => {
    const creativeMapping = useSelector(getCreativeMappingById(id));
    // TODO: wrap with styled components when possible
    const classes = useListStyles();

    return (
        <Box component={Paper}>
            <Divider />
            <ListItem className={classes.row}>
                <Box minWidth={40} p={1} mt={1} mb={1} mr={0.5} ml={0.5} fontWeight="fontWeightBold" />
                <CreativeMappingsForm
                    id={id}
                    isCopy={true}
                    resetOnSubmit={true}
                    onCancelEdit={onCancelEdit}
                    filters={creativeMapping?.filters}
                    creatives={creativeMapping?.creatives}
                />
            </ListItem>
        </Box>
    );
};
